import {
Component,
Injector,
Optional
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";

const DEFAULT_CLS = 'btn app-barcode';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-barcodescanner',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: 'button[wmBarcodeScanner]',
  template: `<i [ngClass]="iconclass" [ngStyle]="{'font-size': iconsize}"></i>
  <span class="btn-caption" [textContent]="caption"></span>`,
  providers: [
    provideAsWidgetRef(BarcodeScannerComponent)
  ],
  exportAs: 'wmBarcodeScanner',
  standalone: true,
  imports: [ CommonModule ],
  styles: []
})
export class BarcodeScannerComponent extends StylableComponent {
  static initializeProps = register('wm-barcodescanner')
  public iconclass: any;
  public iconsize: any;
  public caption: any;

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

}

